import * as React from 'react';

import {TextField} from 'shells/textfield/textfield';

import type {DueDateUnit} from 'nutshell-graphql-types';
import type {TimespanInput} from 'nutshell-graphql-types';

import {DueUnitPicker} from './fields/due-unit-picker';
import {OutcomesSelect} from './outcomes-select';

import styles from './date-time-picker.module.css';

type Props = {
    autocloseDuration: TimespanInput;
    autocloseOutcomeId: string | null | undefined;
    onAutocloseDurationChange: (arg1: TimespanInput) => void;
    onAutocloseOutcomeIdChange: (arg1: string) => void;
};

export class AutocloseDurationInput extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <div className={styles['date-picker']}>
                    <div className={styles['timespan-input']}>
                        <TextField
                            type='number'
                            value={String(this.props.autocloseDuration.timespan)}
                            min='1'
                            selectOnFocus={true}
                            // @ts-expect-error
                            name='autoclose-duration-timespan'
                            onChange={this.handleAutocloseDurationTimespanChange}
                        />
                    </div>
                    <div className={styles['selector-container']}>
                        <DueUnitPicker
                            value={this.props.autocloseDuration.unit}
                            onChange={this.handleAutocloseDurationUnitChange}
                            isSingleUnit={this.props.autocloseDuration.timespan === 1}
                        />
                    </div>
                </div>
                <OutcomesSelect
                    // @ts-expect-error
                    defaultsToFirstItem={true}
                    selectedId={this.props.autocloseOutcomeId}
                    outcomeTypes={['LEAD_CANCELLED', 'LEAD_LOST']}
                    onChange={this.handleAutocloseOutcomeIdChange}
                />
            </div>
        );
    }

    handleAutocloseDurationTimespanChange = (newValue: string) => {
        const newAutocloseDuration = {
            timespan: Number(newValue),
            unit: this.props.autocloseDuration.unit,
        } as const;

        this.props.onAutocloseDurationChange(newAutocloseDuration);
    };

    handleAutocloseDurationUnitChange = (newValue: {id: DueDateUnit}) => {
        const newAutocloseDuration = {
            timespan: this.props.autocloseDuration.timespan,
            unit: newValue.id,
        } as const;

        this.props.onAutocloseDurationChange(newAutocloseDuration);
    };

    handleAutocloseOutcomeIdChange = (newValue: any) => {
        this.props.onAutocloseOutcomeIdChange(newValue.id);
    };
}
